// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { css } from "styled-components";

logoStyles.container = {
    css: css`
        width: 100%;
        padding: 32px 32px 16px 32px;
    `,
};

logoStyles.heading = {
    variant: "h1",
    css: css`
        overflow-wrap: break-word;
        word-wrap: break-word;
        text-align: center;
    `,
};

logoStyles.image = {
    mergeCss: true,
    width: "100%",
    height: "auto",
    css: css`
        img {
            width: 100%;
        }
    `,
};
